module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8ae8345a94ca4f682244962e6dc57c21.gif";